import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import Select, { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { ApexOptions } from "apexcharts";
import "./lead-conversation-trend.scss";
import icons from "../../../../assets/icons/icons";

const LeadConversationTrend = (props: any) => {
  const { leadsConversionRate, handleAddLeadReports, enableExport } =
    props;
  const [fileFormat, setFileFormat] = useState<any>({
    value: "pdf",
    label: "PDF",
  });
  const options: ApexOptions = {
    chart: {
      type: "line",
      id: "conversion-rate",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
          customIcons: [],
        },
      },
    },
    stroke: {
      curve: "straight",
      width: 2,
    },

    dataLabels: {
      enabled: true,
      enabledOnSeries: [0],
      formatter: function (val, opts) {
        const dataLength = opts.w.config.series[opts.seriesIndex].data.length;
        // Show label only on the last data point
        return opts.dataPointIndex === dataLength - 1 ? `${val}` : "";
      },
      offsetY: -2,
      offsetX: -5,
      style: {
        fontSize: "14px",
        fontWeight: 400,
        colors: ["#1C2F8D"],
        fontFamily: "Roboto, sans-serif",
      },
      background: {
        enabled: false,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      title: {
        text: "Conversion Rate in (%)",
        style: {
          fontSize: "14px",
          fontWeight: 400,
          cssClass: "y-axis-title",
        },
      },
    },
    tooltip: {
      // y: {
      //   formatter: (val: number) => `${val}888%`,
      // },
      enabled: true,
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        // Customize this HTML as needed
        return `<div style="padding: 8px;">
          <strong>Month:</strong> ${leadsConversionRate[dataPointIndex]?.month}<br/>
          <strong>Conversion Rate:</strong> ${series[seriesIndex][dataPointIndex]}%<br/>
          <strong>Total Leads:</strong> ${leadsConversionRate[dataPointIndex]?.totalLeads}<br/>
          <strong>Converted Leads:</strong> ${leadsConversionRate[dataPointIndex]?.convertedLeads}
        </div>`;
      },
    },
    colors: ["rgba(6, 94, 16, 1)"],
    grid: {
      borderColor: "#e0e0e0",
    },
  };

  const handleExport = async () => {
    try {
      const response = await ApexCharts.exec("conversion-rate", "dataURI");
      handleAddLeadReports(
        { imageData: response.imgURI.split(",")[1] },
        { section: "conversion-rate", format: fileFormat.value }
      );
    } catch (error) {
      console.error("Error getting base64:", error);
    }
  };

  const series = [
    {
      name: "Lead Conversion Rate",
      data: leadsConversionRate?.map((item: any) => item.conversionRate) || [],
    },
  ];

  return (
    <Box className="lead-conversion-trend-wrapper">
      <Box>
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              padding: "10px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            className="active-users-header"
          >
            <p className="header-text">Lead Conversion Rate Trend</p>
            <Box sx={{ display: "flex", gap: 1 }} className="export-wrapper">
              <Select
                options={[
                  { value: "pdf", label: "PDF" },
                  { value: "csv", label: "CSV" },
                ]}
                isSearchable={false}
                onChange={(e: any) => setFileFormat(e)}
                value={fileFormat}
                className="select-dropdown"
                components={{
                  IndicatorSeparator: () => null,
                  DropdownIndicator: (props) => {
                    return (
                      <components.DropdownIndicator {...props}>
                        <ArrowDropDownIcon
                          style={{ fontSize: 20, color: "black" }}
                        />
                      </components.DropdownIndicator>
                    );
                  },
                }}
              />
              <Button
                variant="outlined"
                onClick={handleExport}
                className="address-edit-button"
                disabled={!enableExport}
              >
                Export
              </Button>
            </Box>
          </Box>
          <Box sx={{ padding: "0px 20px" }}>
            <Chart options={options} series={series} type="line" height={250} />
          </Box>
        </Box>
      </Box>
      <Box className="lead-conversion-trend-footer">
        <Box className="footer-left">
          <img src={icons.LeadReportInfo} />
          <span className="footer-text">
            This chart reflects current year data only
          </span>
        </Box>
        <Box className="footer-right">
          <Box className="dot-wrapper"></Box> <p>Upward Trend</p>
        </Box>
      </Box>
    </Box>
  );
};

export default LeadConversationTrend;
